import Vue from "vue";
import { format, parseISO } from "date-fns";

Vue.filter("date", (d) => {
  if (!d) return "-";
  return format(parseISO(d), "MM/dd/yyyy");
});

Vue.filter("capitalize", (str, lower = false) =>
  (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, (match) =>
    match.toUpperCase()
  )
);
